/**
 * Generated runtime TestId mirror for frontend/src/pages/admin/LifecycleEvents.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const LifecycleEventsTestIds = {
  colActor: "col-actor",
  colChangedAt: "col-changed-at",
  colEntity: "col-entity",
  colFromTo: "col-from-to",
  colReason: "col-reason",
  colTriggerSource: "col-trigger-source",
  lifecycleEventsEmpty: "lifecycle-events-empty",
  lifecycleEventsList: "lifecycle-events-list",
  lifecycleEventsLoading: "lifecycle-events-loading",
  actorSystem: (event_id: string) => `actor-system-${event_id}`,
  actorSystemPrefix: () => "actor-system-" as TestIdPrefix,
  badgeEntity: (event_entityType: string) => `badge-entity-${event_entityType}`,
  badgeEntityPrefix: () => "badge-entity-" as TestIdPrefix,
  entityLink: (event_id: string) => `entity-link-${event_id}`,
  entityLinkPrefix: () => "entity-link-" as TestIdPrefix,
  lifecycleEventRow: (event_id: string) => `lifecycle-event-row-${event_id}`,
  lifecycleEventRowPrefix: () => "lifecycle-event-row-" as TestIdPrefix,
  reasonCell: (event_id: string) => `reason-cell-${event_id}`,
  reasonCellPrefix: () => "reason-cell-" as TestIdPrefix,
  triggerSource: (event_id: string) => `trigger-source-${event_id}`,
  triggerSourcePrefix: () => "trigger-source-" as TestIdPrefix
} as const;
